import styled from "styled-components";

import { ButtonLabel } from "@similarweb/ui-components";

import SignalsManagementButton from "app/pages/sales-intelligence/sub-modules/signals/containers/SignalsManagementButton";

export const StyledSignalsManagementButton = styled(SignalsManagementButton).attrs({ height: 24, iconSize: "12px" })`
    padding: 8px 13px;

    ${ButtonLabel} {
        font-size: 11px;
    }

    &,
    &:hover {
        background-color: none;
    }
`;
